import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState, useLayoutEffect } from 'react';
export function PlanContextMenu({ issue, position, onClose, onAddChild, onOpenInJira, onViewDetails }) {
    const menuRef = useRef(null);
    const [adjusted, setAdjusted] = useState(position);
    // Adjust position after the menu renders so it stays within the viewport
    useLayoutEffect(() => {
        const el = menuRef.current;
        if (!el)
            return;
        const rect = el.getBoundingClientRect();
        const vw = window.innerWidth;
        const vh = window.innerHeight;
        const pad = 8;
        let x = position.x;
        let y = position.y;
        if (x + rect.width + pad > vw)
            x = vw - rect.width - pad;
        if (y + rect.height + pad > vh)
            y = vh - rect.height - pad;
        if (x < pad)
            x = pad;
        if (y < pad)
            y = pad;
        setAdjusted({ x, y });
    }, [position]);
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                onClose();
            }
        };
        const handleEscape = (e) => {
            if (e.key === 'Escape')
                onClose();
        };
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEscape);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscape);
        };
    }, [onClose]);
    const style = {
        position: 'fixed',
        left: adjusted.x,
        top: adjusted.y,
        zIndex: 50,
    };
    return (_jsxs("div", { ref: menuRef, style: style, className: "bg-white border border-border rounded-lg shadow-lg py-1 min-w-[180px]", children: [onViewDetails && (_jsxs("button", { onClick: () => { onViewDetails(issue.issueKey); onClose(); }, className: "w-full text-left px-3 py-2 text-sm hover:bg-surface-muted flex items-center gap-2", children: [_jsxs("svg", { className: "w-4 h-4 text-text-secondary", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: [_jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z" }), _jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" })] }), "View Details"] })), issue.issueType === 'Epic' && (_jsxs("button", { onClick: () => { onAddChild(issue.issueKey, 'Story'); onClose(); }, className: "w-full text-left px-3 py-2 text-sm hover:bg-surface-muted flex items-center gap-2", children: [_jsx("span", { className: "w-4 h-4 flex items-center justify-center rounded-sm bg-green-100 text-green-700 text-[10px] font-bold", children: "S" }), "Add Story"] })), (issue.issueType === 'Story' || issue.issueType === 'Task') && (_jsxs("button", { onClick: () => { onAddChild(issue.issueKey, 'Sub-task'); onClose(); }, className: "w-full text-left px-3 py-2 text-sm hover:bg-surface-muted flex items-center gap-2", children: [_jsx("span", { className: "w-4 h-4 flex items-center justify-center rounded-sm bg-blue-100 text-blue-700 text-[10px] font-bold", children: "T" }), "Add Sub-task"] })), _jsx("div", { className: "border-t border-border my-1" }), _jsxs("button", { onClick: () => { onOpenInJira(issue.issueKey); onClose(); }, className: "w-full text-left px-3 py-2 text-sm hover:bg-surface-muted flex items-center gap-2", children: [_jsx("svg", { className: "w-4 h-4 text-text-secondary", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: _jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" }) }), "Open in Jira"] })] }));
}
//# sourceMappingURL=PlanContextMenu.js.map